import React from 'react';
import PropTypes from 'prop-types';
import {
  NavTabs,
  NavTabsWithButtons,
  Tabs,
  ButtonLeft,
  ButtonRight
} from './styleTabsHorizontal';

const TabsHorizontal = ({
  className,
  activeIndex,
  withButtons,
  children,
  onClickArrow,
  leftDisabled,
  rightDisabled,
  posX
}) => {
  const MainTabs = withButtons ? NavTabsWithButtons : NavTabs;
  return (
    <MainTabs
      className={className}
      left={leftDisabled}
      right={rightDisabled}
      posX={posX}
    >
      {withButtons && (
        <ButtonLeft
          disabled={leftDisabled}
          onClick={() => onClickArrow(activeIndex - 1)}
        />
      )}
      <Tabs activeIndex={activeIndex} posX={posX}>
        {children}
      </Tabs>
      {withButtons && (
        <ButtonRight
          disabled={rightDisabled}
          onClick={() => onClickArrow(activeIndex + 1)}
        />
      )}
    </MainTabs>
  );
};

TabsHorizontal.propTypes = {
  activeIndex: PropTypes.number,
  children: PropTypes.node.isRequired,
  onClickArrow: PropTypes.func,
  className: PropTypes.string,
  rightDisabled: PropTypes.bool,
  leftDisabled: PropTypes.bool,
  withButtons: PropTypes.bool,
  posX: PropTypes.number
};

TabsHorizontal.defaultProps = {
  withButtons: false,
  posX: 0
};

export default TabsHorizontal;
